var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: {
            followCursor: true,
            placement: "bottom-end",
            delay: [300, 0],
          },
          expression:
            "{ followCursor: true, placement: 'bottom-end', delay: [300, 0] }",
        },
      ],
      staticClass: "last-message",
      class: {
        "special-message": _vm.isSpecialMessage,
        "visitor-message": _vm.lastMessageSender.includes("visitor"),
        "agent-message": _vm.lastMessageSender.includes("user"),
      },
      attrs: { content: _vm.lastMessageText },
    },
    [
      _vm.lastMessageIcon
        ? _c("div", { staticClass: "message-icon" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v(_vm._s(_vm.lastMessageIcon)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "message-text" }, [
        _vm._v(_vm._s(_vm.lastMessageText)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }